import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  GetStudentScheduleForRecipientRequest,
  GetStudentScheduleForRecipientResponse,
} from '../student_schedule/student_schedule_pb';

import {
  StudentScheduleManager as __StudentScheduleManager,
} from '../student_schedule/student_schedule_pb_service';

@Injectable({providedIn: 'root'})
export class StudentScheduleManager {

  constructor(private _ngZone: NgZone) {
  }

  getStudentScheduleForRecipient(request: GetStudentScheduleForRecipientRequest): Promise<GetStudentScheduleForRecipientResponse>;
  getStudentScheduleForRecipient(request: GetStudentScheduleForRecipientRequest, metadata: grpc.Metadata): Promise<GetStudentScheduleForRecipientResponse>;
  getStudentScheduleForRecipient(request: GetStudentScheduleForRecipientRequest, callback: (err: any|null, response: GetStudentScheduleForRecipientResponse, metadata: grpc.Metadata) => void): void;
  getStudentScheduleForRecipient(request: GetStudentScheduleForRecipientRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetStudentScheduleForRecipientResponse, metadata: grpc.Metadata) => void): void;

  getStudentScheduleForRecipient(request: GetStudentScheduleForRecipientRequest, arg1?: grpc.Metadata|((err: any|null, response: GetStudentScheduleForRecipientResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetStudentScheduleForRecipientResponse, metadata: grpc.Metadata) => void): Promise<GetStudentScheduleForRecipientResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetStudentScheduleForRecipientResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__StudentScheduleManager.GetStudentScheduleForRecipient, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

